import { render, staticRenderFns } from "./success.vue?vue&type=template&id=74f515aa&scoped=true&"
import script from "./success.vue?vue&type=script&lang=ts&"
export * from "./success.vue?vue&type=script&lang=ts&"
import style0 from "./success.vue?vue&type=style&index=0&id=74f515aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f515aa",
  null
  
)

export default component.exports